// 用户
import api from './http'
// 获取用户信息 (包含证件)
export function getUserInfo (params) {
  return api.post('/passengerRegular/queryPassengerInfo', params, {
    headers: {
      load: false
    }
  })
}
// 个人帐号信息（包含预订）
export function getPerInfo (params) {
  return api.post('/passengerRegular/queryPassengerServiceInfo', params)
}

// 个人帐号信息修改
export function editUserInfo (params) {
  return api.post('/passengerRegular/updatePassengerService', params)
}

// 获取常旅客的列表
export function getSelectPageList (params, load) {
  return api.post('/passengerRegular/selectPageList', params, {
    headers: {
      load: !load
    }
  })
}

// 修改用户信息
export function updateUserInfo (params) {
  return api.post('/passengerRegular/addAndUpdatePassenger', params)
}

// 新增修改临客
export function andAndUpdateTem (params) {
  return api.post('/passengerRegular/addAndUpdateTemPassenger', params)
}
// 删除常客
export function delUser (params) {
  return api.post('/passengerRegular/deletePassenger', params)
}

// 临客管理查询分页查询

export function getSelectTemporary (params) {
  return api.post('/passengerRegular/selectPassengerInfoPage', params)
}

// 用户密码修改
export function editPassword (params) {
  return api.post('/passenger/updatePassword', params)
}

// 预订人常旅客查询
export function selQueryReserve (params) {
  return api.post('/passengerRegular/queryReserveSubject', params, {
    headers: {
      reserveBy: params.reserveBy
    }
  })
}

// 预订人新增常旅客
export function addReserveSub (params) {
  return api.post('/passengerRegular/addReserveSubject', params, {
    headers: {
      reserveBy: params.reserveBy,
      passengerId: params.passengerId

    }
  })
}

// 预订人删除常旅客
export function delReservSub (params) {
  return api.post('/passengerRegular/deleteReserveSubject', params, {
    headers: {
      id: params.id

    }
  })
}

// 当前用户查询差旅规则
export function selQueTra (params) {
  return api.post('/travelRule/queryTravelRuleByLogin', params)
}

// 当前用户查询审批规则
export function selAppRul (params) {
  return api.post('/approvalRules/queryApproverRuleByLogin', params)
}

// 当前用户审批
export function findApproveOrderList (params) {
  return api.post('/trandeApprove/findApproveOrderList', params, {
    headers: {
      load: false
    }
  })
}
// 申请审批
export function beforeApprovePage (params) {
  return api.post('/trandeApprove/beforeApprovePage', params)
}
// 根据可选条件分页查询未与审批规则关联的员工数据
export function pageDataNotSubject (params) {
  return api.post('/approvalRules/pageDataNotSubject', params)
}
// 根据可选条件分页查询未与差旅规则关联的员工数据
export function pagePassengerNotSubject (params) {
  return api.post('/travelRule/pagePassengerNotSubject', params)
}

// 角色列表查询
export function getRolePage (params) {
  return api.post('/cps/role/getPage', params, {
    headers: {
      load: false
    }
  })
}
// 查询角色，供用户选择
export function getRoles (params) {
  return api.post('/cps/role/getRoles', params)
}
// 删除角色
export function deleteRole (params) {
  return api.post('/cps/role/delete', params)
}
// 新增或修改角色
export function editRole (params) {
  return api.post('/cps/role/roleEdit', params)
}
// 角色详情查询
export function queryRoleDetail (params) {
  return api.post('/cps/role/queryDetail', params)
}
// 角色菜单
export function getPermissionTree (params) {
  return api.post('/cps/role/permissionTree', params)
}

// 查询职级
export function jobGradeList (params) {
  return api.post('/cps/jobGrade/queryList', params, {
    headers: {
      load: false
    }
  })
}
// 新增或修改职级
export function jobGradeEdit (params) {
  return api.post('/cps/jobGrade/edit', params, {
    headers: {
      load: false
    }
  })
}
// 批量修改职级
export function jobGradeBatchUpdate (params) {
  return api.post('/cps/jobGrade/batchUpdate', params, {
    headers: {
      load: false
    }
  })
}
// 商旅账单分页查询
export function selectPage (params) {
  return api.post('/settlement/selectPage', params, {
    headers: {
      load: false
    }
  })
}
// 获取账单详情
export function productDetailsPage (params) {
  return api.post('/settlement/productDetailsPage', params, {
    headers: {
      load: false
    }
  })
}
// 账单产品表头查询
export function getReportHead (params) {
  return api.post('/settlement/getReportHead', params)
}
// 获取各个产品的总销售额
export function billTotalPrice (params) {
  return api.post('/settlement/billTotalPrice', params)
}



// WEBPACK FOOTER //
// ./src/axios/userApi.js